import { apiGet, apiPost } from '.'

export interface BlockRequestPayload {
  contact_id?: number
  identity_id?: number
  reason?: string
}

export interface BlockEntry {
  id: number
  blocked_at: string
  reason: string | null
}

export interface BlockedContact extends BlockEntry {
  contact_id: number
  name: string
  location: string | null
}

export interface BlockedIdentity extends BlockEntry {
  identity_id: number
  contact_id: number
  display_name: string
  platform: string
}

export interface BlocklistResponse {
  contacts: BlockedContact[]
  identities: BlockedIdentity[]
}

export async function block(stationId: number, payload: BlockRequestPayload): Promise<{ ok: boolean }> {
  return apiPost<{ ok: boolean }>('block', {
    station_id: stationId,
    ...payload,
  })
}

export async function unblock(stationId: number, payload: BlockRequestPayload): Promise<{ ok: boolean }> {
  return apiPost<{ ok: boolean }>('unblock', {
    station_id: stationId,
    ...payload,
  })
}

export async function getBlocklist(stationId: number): Promise<BlocklistResponse> {
  return apiGet<BlocklistResponse>(`blocklist?station_id=${stationId}`)
}

